"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectNameDialogComponent = void 0;
var widgets_1 = require("@tableau/widgets");
var React = require("react");
var Localize_1 = require("../../../../gen-src/Localize");
var styles = require("../../../styles/LayoutStyles");
var TestIds_1 = require("../../../util/TestIds");
var NAME_MAX_LENGTH = 255;
var SelectNameDialogComponent = /** @class */ (function (_super) {
    __extends(SelectNameDialogComponent, _super);
    function SelectNameDialogComponent(props) {
        var _this = _super.call(this, props) || this;
        _this.handlePredictiveModelNameChange = function (e) {
            var lengthControlledName = e.target.value.slice(0, NAME_MAX_LENGTH);
            _this.setState({ predictiveModelName: lengthControlledName });
            _this.props.onNameChanged(lengthControlledName);
        };
        _this.state = { predictiveModelName: props.initialPredictiveModelName };
        return _this;
    }
    SelectNameDialogComponent.prototype.render = function () {
        return (React.createElement(widgets_1.TextFieldWidget, { label: Localize_1.Messages.deployModelDialogSelectProjectNameLabel(), testId: TestIds_1.DEPLOY_MODEL_DIALOG_NAME_FIELD, kind: 'outline', value: this.state.predictiveModelName, onChange: this.handlePredictiveModelNameChange, className: styles.predictiveModelEditorDeploySelectName, style: { width: '100%' } }));
    };
    return SelectNameDialogComponent;
}(React.Component));
exports.SelectNameDialogComponent = SelectNameDialogComponent;
//# sourceMappingURL=SelectNameDialogComponent.js.map